import { SplitButton } from '@ohif/ui';

export default SplitButton;
